import { render, staticRenderFns } from "./SignUpSuccessMessage.vue?vue&type=template&id=4bd72abc"
import script from "./SignUpSuccessMessage.vue?vue&type=script&lang=js"
export * from "./SignUpSuccessMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports